import { createGtmConsentSignal } from '../../lib/consent/gtmConsent'
import type { ConsentState } from '../../lib/consent/contract'
import { isConsentRequiredOnClient } from './clientScope'

export function publishGtmConsent(state?: ConsentState): void {
  if (typeof window === 'undefined') return
  const modeEnabled = window.__LE_CONSENT__?.modeEnabled === true
  const signal = createGtmConsentSignal(isConsentRequiredOnClient(), modeEnabled, state)
  window.__LE_CONSENT__ = signal
  if (!modeEnabled) return
  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'le_consent_update' })
  } catch {
    // GTM failures must not interrupt saved choices, cleanup or reload.
  }
}
